import { useRef, useEffect, useState } from 'react';
import { formatDate, getLastDate } from '../../../../lib/utils';
import { ReactComponent as CalendarSearchSvg } from '../../../../assets/svg/calendar-search.svg';
import request from '../../../../lib/request';
import CreateDialog from './createDialog';
import MeasurementLogBook from './logBook';

const MeasurementProgress = () => {
  const createDialogRef = useRef(null);

  const [measurements, setMeasurements] = useState([]);
  const [tableData, setTableData] = useState([]);
  const [isCreateDialogOpen, setIsCreateDialogOpen] = useState(false);
  const [dataRange, setDataRange] = useState('30');

  useEffect(() => {
    const today = formatDate(new Date());
    const lastDate = formatDate(getLastDate(dataRange));

    getMeasurements(lastDate, today);
  }, [dataRange]);

  const getMeasurements = async (startDate, endDate) => {
    try {
      const { result } = await request.get(
        `/log/measurement?startDate=${startDate}&endDate=${endDate}`
      );

      const logList = [];

      if (Array.isArray(result) && result.length > 0) {
        result.forEach((log) => {
          const logItem = {
            date: log.logDate,
            armThigh: {
              headers: ['R-Arm', 'L-Arm', 'R-Thigh', 'L-Thigh'],
              bodies: [
                [
                  log.rArmSize ?? '-',
                  log.lArmSize ?? '-',
                  log.rThighSize ?? '-',
                  log.lThighSize ?? '-',
                ],
              ],
            },
            waistHips: {
              headers: ['Waist', 'Hips'],
              bodies: [[log.waistSize ?? '-', log.hipsSize ?? '-']],
            },
          };

          logList.push(logItem);
        });
      }

      setTableData(logList);
      setMeasurements(result);
    } catch (err) {
      console.log(err.response.data.error);
    }
  };

  const refreshList = async () => {
    const today = formatDate(new Date());
    const lastDate = formatDate(getLastDate(dataRange));

    await getMeasurements(lastDate, today);
  };

  const openCreateDialog = () => {
    if (createDialogRef.current) {
      createDialogRef.current.showModal();
      setIsCreateDialogOpen(true);
    }
  };

  const closeCreateDialog = () => {
    if (createDialogRef.current) {
      createDialogRef.current.close();
      setIsCreateDialogOpen(false);
    }
  };

  const handleSelectRange = (e) => {
    setDataRange(e.target.value);
  };

  return (
    <div className='space-y-4'>
      <div className='flex justify-end items-center'>
        <select
          onChange={handleSelectRange}
          className='rounded-full px-2 py-1 bg-tertiary  text-white'
        >
          <option value='30'>Last 30 days</option>
          <option value='90'>Last 90 days</option>
          <option value='half'>Last 6 months</option>
          <option value='year'>Last 12 months</option>
        </select>
        <CreateDialog
          dialogRef={createDialogRef}
          closeDialog={closeCreateDialog}
          isDialogOpen={isCreateDialogOpen}
          refresh={refreshList}
        />
      </div>
      {tableData.length > 0 && (
        <MeasurementLogBook
          logs={measurements}
          tableData={tableData}
          openCreateDialog={openCreateDialog}
          refresh={refreshList}
        />
      )}
      {measurements.length === 0 && (
        <div className='flex flex-col justify-center items-center'>
          <div className='flex flex-col justify-center items-center py-12'>
            <div className='w-20 h-20 opacity-10'>
              <CalendarSearchSvg
                className='w-full h-full'
                fill='white'
              />
            </div>
            <p className='opacity-20 text-center text-white'>No logs</p>
          </div>
          <button
            className='flex justify-center items-center text-white border px-3 py-2 rounded-full'
            onClick={openCreateDialog}
          >
            + Add your measurement
          </button>
        </div>
      )}
    </div>
  );
};

export default MeasurementProgress;
